import lazyScreen from '../utils/lazyScreen';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QuickPopupRegistry, QuickPopupStackManager, QuickPopupStackAPI } from 'ante-react-kit';
// ante-web/src/config/init-quick-popups.js
// Đăng ký tất cả QuickPopup components + mount QuickPopupStackManager vào DOM



const BusinessEntityQuickPopup = lazyScreen(() => import('../pages/crm/QuickPopups/BusinessEntityQuickPopup.js'), 'pages/crm/QuickPopups/BusinessEntityQuickPopup.js');
const CustomerQuickPopup = lazyScreen(() => import('../pages/crm/QuickPopups/CustomerQuickPopup.js'), 'pages/crm/QuickPopups/CustomerQuickPopup.js');

// Đăng ký pilots
QuickPopupRegistry.register('BusinessEntity', BusinessEntityQuickPopup, {
    whenUserScreen: 'BusinessEntities'
});
QuickPopupRegistry.register('Customer', CustomerQuickPopup, {
    whenUserScreen: 'Customers'
});

// Mount StackManager vào root DOM riêng — non-invasive, không chạm vào AntReact tree
// Defer tới sau khi main React tree mount xong để tránh race condition
function mountQuickPopupStack() {
    if (typeof window === 'undefined') return;
    if (document.getElementById('ant-quick-popup-stack-root')) return;
    const container = document.createElement('div');
    container.id = 'ant-quick-popup-stack-root';
    document.body.appendChild(container);
    ReactDOM.createRoot(container).render(React.createElement(QuickPopupStackManager));

    // Expose for console debug/smoke test
    window.__quickPopup = { StackAPI: QuickPopupStackAPI, Registry: QuickPopupRegistry };
}

if (typeof window !== 'undefined') {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(mountQuickPopupStack, 0);
    } else {
        window.addEventListener('DOMContentLoaded', () => setTimeout(mountQuickPopupStack, 0));
    }
}

export default true;
